import {InjectionToken} from '@angular/core';
import {User} from './user.interface';


export const DA_STORE_USER = new InjectionToken<User>('AUTH_STORE_USER');

export interface UserStore {
  get(key: string): User;

  set(key: string, value: User): boolean;

  remove(key: string);
}
